import React from 'react'
import { MapBrazil } from '../MapBrasil'
import { MapBrazilProps } from '../MapBrasil/types'

export const MapBrazilVendas: React.FC<MapBrazilProps> = (props) => {
  return <MapBrazil {...props} isVolumeMode={false} unitLabel='PDVs Ativos (R$)' />
}

export default MapBrazilVendas
